module.exports = {"410225001":"兰阳街道","410225002":"桐乡街道","410225003":"惠安街道","410225101":"堌阳镇","410225102":"南彰镇","410225103":"考城镇","410225104":"红庙镇","410225105":"谷营镇","410225201":"三义寨乡","410225202":"东坝头乡","410225205":"小宋乡","410225206":"孟寨乡","410225207":"许河乡","410225208":"葡萄架乡","410225209":"阎楼乡","410225210":"仪封乡","410225400":"中原石油勘探三公司","410225401":"仪封园艺场","410225402":"造纸林场","410225403":"柳林林场","410225404":"西关农场","410225405":"畜牧良种农场","410225406":"固阳农科所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410225.json
// module id = 1537
// module chunks = 0